import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, FormControl, FormGroup, Validators } from '@angular/forms';
import { BusyModule } from 'angular2-busy';
import { RouterModule, Routes } from '@angular/router';

import { SecurityService } from './security.service';

import { LoginComponent } from './login/login.component';

const SecurityRoutes: Routes = [
    { path: 'login', component: LoginComponent }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        BusyModule,
        RouterModule.forChild(SecurityRoutes)
    ],
    declarations: [
        LoginComponent
    ],
    providers: [
        SecurityService
    ]
})
export class SecurityModule { }



// WEBPACK FOOTER //
// ./src/app/security/security.module.ts